'use client';

import { useQuery } from '@apollo/client';
import cookies from 'js-cookie';
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';

// import { client } from '@/helpers/apollo/client';
// import { createCartMutation } from '@/helpers/apollo/mutations/cart';
import { GET_CART_QUERY } from '@/helpers/apollo/queries/cart';

export const CART_ID_COOKIE_NAME = 'cart-id';

const initialStore = {
  id: null,
  open: false,
  loading: false,
  networkStatus: null,
  error: null,
  data: null,
};

const Store = createContext([{}, {}]);

export const useCart = () => {
  return useContext(Store);
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(initialStore);

  const set = useCallback(
    (name, value) => {
      setCart((state) => {
        const updated = Object.assign({}, state);

        updated[name] = value;

        return updated;
      });
    },
    [setCart],
  );

  // const setId = useCallback(
  //   (id) => {
  //     set('id', id);
  //     cookies.set(CART_ID_COOKIE_NAME, id);
  //   },
  //   [set],
  // );

  const result = useQuery(GET_CART_QUERY, {
    variables: {
      cartId: cart.id,
    },
    notifyOnNetworkStatusChange: true,
    skip: !cart.id, // Only execute the query if a cartId is provided
  });

  useEffect(() => {
    set('loading', result.loading);
    set('networkStatus', result.networkStatus);
    set('error', result.error);
    set('data', result.data?.cart);
  }, [set, result]);

  // const [createCart] = useMutation(createCartMutation);

  // useEffect(() => {
  //   (async () => {
  //     const storedCartId = cookies.get(CART_ID_COOKIE_NAME);

  //     if (storedCartId) {
  //       const result = await client.query({
  //         query: GET_CART_QUERY,
  //         variables: {
  //           cartId: storedCartId,
  //         },
  //       });

  //       if (result.data && result.data.cart) {
  //         setId(storedCartId);

  //         return;
  //       }
  //     }

  //     const createCartResult = await createCart({
  //       variables: {
  //         lineItems: [],
  //       },
  //     });

  //     const createdCartId = createCartResult.data.cartCreate.cart.id;

  //     setId(createdCartId);
  //   })();
  // }, []);

  const actions = {
    set,
  };

  return <Store.Provider value={[cart, actions]}>{children}</Store.Provider>;
};
